import { useQuery } from "react-query";
import {
  getCancelledOptions,
  getMyDirectOrders,
} from "../../actions/my-orders/services";
import MyOrdersTable from "./MyOrdersTable";

const columns = [
  "Reference",
  "Order Name",
  "Sent Date",
  "Team",
  "Articles Count",
  "Order Details",
];
const cancelledColumns = [
  "Option Name",
  "Article Name",
  "Order Name",
  "Delete Date",
  "Actions",
];

export default function DirectOrders({
  orderType,
  url,
  orderStatus,
  selectedDate,
}: {
  orderType: string;
  url: string;
  orderStatus: string;
  selectedDate: any;
}) {
  const { data, isLoading, isFetching, isError, refetch } = useQuery(
    ["my_direct_orders", orderStatus, selectedDate],
    orderStatus === "cancelled"
      ? () => getCancelledOptions(selectedDate)
      : () => getMyDirectOrders(selectedDate),
    {
      keepPreviousData: true,
    }
  );

  if (isError) {
    return <p>Error!</p>;
  }

  return (
    <div>
      <MyOrdersTable
        columns={orderStatus === "cancelled" ? cancelledColumns : columns}
        isLoading={isLoading || isFetching}
        orderType={orderType}
        data={data?.data}
        orderStatus={orderStatus}
        url={url}
        refetch={refetch}
      />
    </div>
  );
}
